import { ButtonBase } from '@bonniernews/dn-design-system-web/components/button/button-base.tsx'
import type { ButtonProps } from '@bonniernews/dn-design-system-web/components/button/button-types.ts'

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/button](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/button)
 * - Storybook: [Buttons > Button](https://designsystem.dn.se/?path=/docs/basic-buttons-button--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/button/button.scss'`
 */
export const Button = ({
  text,
  disabled = false,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  mobileFullWidth = false,
  iconPosition = 'none',
  iconName,
  loading = false,
  type = 'button',
  href,
  isIconButton = false,
  classNames,
  attributes,
  forcePx = false,
}: ButtonProps) => {
  return (
    <ButtonBase
      {...{
        text,
        disabled,
        variant,
        size,
        fullWidth,
        mobileFullWidth,
        iconPosition,
        iconName,
        loading,
        type,
        href,
        isIconButton,
        classNames,
        attributes,
        forcePx,
      }}
    />
  )
}

export default Button
